module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAcCAYAAABRVo5BAAAAAXNSR0IArs4c6QAAAHhJREFUOE+l1MENwCAMA8AwFt1/sAokEIWQ2C7/wx87xbRXi+CqmT0s7KiFMXAiBn4QCg+EQBdl8IoiGKIbTJEHIbRDGK2QQgPS6DdsH9Cpa8kpvK8Dxt6sIHzbY4qjIUslH6dImlWI0ZsjnQ43GU08MAtnPRXY8QsQpAw9ahRVawAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/status/01dailyActive/03left.png
// module id = IKtx
// module chunks = 0